<div class="flex flex-col">
  <div>
    <div class="text-5xl m-10">
      WE7 Integrations
    </div>
  </div>
  <div class="flex flex-col gap-4">
    @for(integration of integrations; track integration.id) {
      <div
        [routerLink]="integration.usedByCustomer ? '/integrations/' + integration.id + '/settings' : ''"
              class="mx-10 p-10 text-xl flex flex-row space-x-10 {{ integration.usedByCustomer ? 'bg-blue-600 text-white cursor-pointer' : 'bg-white' }}">
        <div>
          <img alt="{{integration.id}} icon logo" src="../assets/{{integration.id}}_icon_logo.png" height="25" width="25" [class.invert]="integration.usedByCustomer" />
        </div>
        <div>{{integration.name}}</div>
        @if(integration.usedByCustomer) {
          <div class="flex flex-row items-center">
            <div class="mr-2">{{'go_to_settings' | translate}}</div>
            <mat-icon>arrow_forward</mat-icon>
          </div>
        } @else {
          <div>
            <mat-icon>arrow_forward</mat-icon>
          </div>
        }
      </div>
    }
    <div class="p-5">
    </div>
    @if (user) {
      <div
              routerLink="/events"
              class="mx-10 p-10 bg-white text-xl flex flex-row space-x-14 cursor-pointer">
        <div>Events</div>
        <div>
          <mat-icon>arrow_forward</mat-icon>
        </div>
      </div>
    }
  </div>
</div>
